import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import jobActions from '../../../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { executeAction } from '../../../../../../helpers/api';
import { keyByProperty } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

function* sendUndoNCNSRequest({ payload }) {
  try {
    const { editForm, url, method, jobId, cb, pages } = payload;
    const propsArray = Object.values(editForm);
    const data = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);

    if (result && (result.messages || result.success)) {
      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', {
            item: t('dash.jobs.bookings.shift_title'),
          }),
        }),
      );
      yield put(actions.sendSuccess());

      if (cb) {
        cb();
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SEND_REQUEST, sendUndoNCNSRequest)]);
}
